module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入账号/真实姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1), _c('span', {
    staticClass: "m-l-30",
    staticStyle: {
      "color": "#111"
    }
  }, [_vm._v("企业："), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700",
      "margin-top": "7px",
      "color": "#111"
    }
  }, [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_head",
      "label": "头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right-end",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "100%"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "50",
            "height": "50"
          },
          slot: "reference"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "账号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "真实姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "加入时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.examine_status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("通过")]) : (scope.row.examine_status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v("审核中")]) : (scope.row.examine_status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v("删除")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14dd7ed2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/company/company_user.vue
// module id = 1806
// module chunks = 2